/* eslint-disable */

import { Injectable } from '@angular/core';
import { CONSTANTS } from '../config.service';
import { LoggerService } from '../logger.service';
import { PosterService } from '../poster.service';
import { SqlHelperService } from '../sql-helper.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class TimeLoggerService {
  db;
  table = 'questionTiming';
  initialized = false;
  /* from server, doesn't match CONSTANTS - for server
        SURVEY_TYPE_TRIP = 0
        SURVEY_TYPE_SUMMARY = 1
        SURVEY_TYPE_SIGNUP = 2
    */
  SURVEY_TYPES = { TRIP: 0, DAY: 1, SIGNUP: 2 };

  constructor(
    private logger: LoggerService,
    private poster: PosterService,
    private sqlHelper: SqlHelperService
  ) {}

  add(surveyType, surveyId, questionName, milliseconds) {
    if (!this.initialized) {
      this.logger.log('Not logging timing before init for ', MSRemoteLoggerCategory.SURVEY_TIME_LOGGER_SERVICE, questionName);
      return Promise.resolve();
    }
    return this.sqlHelper.getInsertPromise(this.db, this.table, { surveyType, surveyId, questionName, milliseconds });
  }

  // call 1x (when done) - sends all
  send() {
    return this.sqlHelper
      .getSelectPromise(this.db, this.table, ['*'], null, 'id ASC')
      .then((rows) => {
        // sending more often, so don't bother posting unless we have something
        if (rows.length === 0) {
          return Promise.resolve();
        }

        // headers on first row then array of other rows - upgradeable and compact
        let results = [['id', 'surveyType', 'surveyId', 'questionName', 'milliseconds']];
        results = results.concat(rows.map((row) => [row.id, row.surveyType, row.surveyId, row.questionName, row.milliseconds]));
        return this.poster.addThenSend('/save_question_times', { times: results });
      })
      .then((res) => this.sqlHelper.getDeletePromise(this.db, this.table, null))
      .catch((err) => {
        this.logger.error('Error sending q timings to server ', MSRemoteLoggerCategory.SURVEY_TIME_LOGGER_SERVICE, err);
      });
  }

  initialize() {
    return this.sqlHelper
      .createDb({ name: CONSTANTS.mainFrontEndDbName, location: 'default', androidDatabaseProvider: 'system', androidLockWorkaround: 1 })
      .then((db) => {
        this.db = db;
        return this.sqlHelper.createTablePromise(
          this.db,
          'CREATE TABLE IF NOT EXISTS ' +
            this.table +
            ' ( ' +
            'id INTEGER primary key autoincrement, ' +
            'surveyType INTEGER, ' +
            'surveyId INTEGER, ' +
            'questionName TEXT, ' +
            'milliseconds INTEGER, ' +
            'UNIQUE(surveyType, surveyId, questionName) ON CONFLICT IGNORE' + // keep just the first
            ')'
        );
      })
      .then(() => {
        this.initialized = true;
      });
  }
}
